// Central brand + asset config (editable)
const BASE =
  "https://customer-assets-0z36b82j.emergentagent.net/job_b4e9f572-071f-49ed-852d-412ebafac94b/artifacts";

export const ASSETS = {
  logo: `${BASE}/lhop1ehq_NEW%20LOGO.jpeg`,
  plainTango: "/products/plain-tango.jpg",
  beetrootPiri: "/products/beetroot-piri.jpg",
  moringaTango: "/products/moringa-tango.jpg",
  palakPiri: "/products/palak-piri.jpg",
  palakTango: "/products/palak-tango.jpg",
};

export const VIDEOS = {
  modelBeetroot: "/media/model-beetroot.mp4",
  beetroot: "/media/beetroot-soya.mp4",
  beetroot2: "/media/beetroot-2.mp4",
  moringaReview: "/media/moringa-review.mp4",
  palak: "/media/palak-soya.mp4",
};

export const BRAND = {
  name: "Dignity Food Kitchen",
  tagline: "Good Food • Healthy Living",
  secondary: "Snack Smart. Live Bold.",
  phone: "+91 80 3180 4599",
  emails: {
    ceo: "ceo@dignityfoodkitchen.com",
    sales: "sale@dignityfoodkitchen.com",
    marketing: "marketing@dignityfoodkitchen.com",
    support: "support@dignityfoodkitchen.com",
  },
  address: "Dignity Food Kitchen, India",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
  },
};

export const FLAVOUR_COLORS = {
  piri_piri: "#FF5722",
  tango_tomato: "#D32F2F",
  palak: "#4CAF50",
  beetroot: "#B01466",
};

export const USP_ITEMS = [
  { icon: "Dumbbell", label: "High Protein", desc: "8g plant protein per serving" },
  { icon: "Leaf", label: "100% Vegetarian", desc: "Pure veg, always" },
  { icon: "Wheat", label: "Good Source of Fiber", desc: "Keeps you fuller, longer" },
  { icon: "Droplet", label: "Rich in Iron", desc: "Iron-focused recipes" },
  { icon: "Palette", label: "No Artificial Colours", desc: "Real ingredient colour" },
  { icon: "ShieldCheck", label: "No Preservatives", desc: "Clean label snacking" },
  { icon: "Flame", label: "Less-Oil Preparation", desc: "Baked, then lightly fried" },
];

export const PROCESS_STEPS = [
  { title: "Quality Ingredients", desc: "Handpicked soya, real spices and herbs." },
  { title: "Mixed & Prepared", desc: "Blended into a perfectly balanced dough." },
  { title: "Sheeted & Cut", desc: "Rolled thin and cut into signature shapes." },
  { title: "Baked", desc: "Baked first to lock in the crunch." },
  { title: "Lightly Fried", desc: "A quick, less-oil finish for texture." },
  { title: "Seasoned", desc: "Tossed in bold, distinctive flavour blends." },
  { title: "Packed Fresh", desc: "Sealed fresh to keep every bite crisp." },
];

export const FLAVOURS = [
  { key: "piri_piri", emoji: "🌶", name: "Piri Piri", tagline: "Bold. Spicy. Addictive.", color: "#FF5722" },
  { key: "tango_tomato", emoji: "🍅", name: "Tango Tomato", tagline: "Tangy. Zesty. Irresistible.", color: "#D32F2F" },
  { key: "palak", emoji: "🥬", name: "Palak", tagline: "Green. Savoury. Distinctive.", color: "#4CAF50" },
  { key: "beetroot", emoji: "❤️", name: "Beetroot", tagline: "Bold Colour. Bold Taste.", color: "#B01466" },
];

export const TRUST_ITEMS = [
  { icon: "Lock", label: "Secure Checkout" },
  { icon: "PackageCheck", label: "Freshly Packed" },
  { icon: "Sprout", label: "Quality Ingredients" },
  { icon: "Truck", label: "Fast Delivery" },
  { icon: "Headphones", label: "Easy Support" },
];

export const REVIEWS = [
  { name: "[Customer Name]", location: "[City]", rating: 5, text: "[Placeholder review — replace with a real verified customer testimonial about the crunch and flavour.]" },
  { name: "[Customer Name]", location: "[City]", rating: 5, text: "[Placeholder review — highlight the protein content and guilt-free snacking experience here.]" },
  { name: "[Customer Name]", location: "[City]", rating: 4, text: "[Placeholder review — mention favourite flavour and repeat-purchase intent.]" },
  { name: "[Customer Name]", location: "[City]", rating: 5, text: "[Placeholder review — talk about packaging quality and freshness on delivery.]" },
];
